/* eslint-disable */

import { getMachineCurrentLocationName } from "utils/machineCurrentLocation";

const textCollator = new Intl.Collator("es", { sensitivity: "base" });
const serialCollator = new Intl.Collator("es", { sensitivity: "base", numeric: true });
const idCollator = new Intl.Collator("es", { numeric: true });

export const normalizeMachineName = (value) =>
  String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("es")
    .trim();

function sortValue(machine, column, expectedLocalType) {
  switch (column) {
    case "Name":
      return machine.Name;
    case "SerialNumber":
      return machine.SerialNumber;
    case "MachineTypeType":
      return machine.MachineType?.Type;
    case "CurrentLocation": {
      const location = getMachineCurrentLocationName(machine, expectedLocalType);
      return location === "—" ? null : location;
    }
    case "CreationDate":
    case "EliminatedDate": {
      const timestamp = machine[column];
      if (timestamp == null || timestamp === "") return null;
      const time = new Date(timestamp).getTime();
      return Number.isNaN(time) ? null : time;
    }
    default:
      return null;
  }
}

export function filterAndSortMachines(machines, query, sort, expectedLocalType) {
  const searchQuery = normalizeMachineName(query);
  const filtered = searchQuery
    ? machines.filter((machine) =>
        [
          machine.Name,
          machine.SerialNumber,
          getMachineCurrentLocationName(machine, expectedLocalType),
        ].some((value) =>
          value != null && value !== "—" && normalizeMachineName(value).includes(searchQuery)
        )
      )
    : machines;

  if (!sort?.column) return filtered;

  return filtered
    .map((machine, index) => ({ machine, index }))
    .sort((left, right) => {
      const a = sortValue(left.machine, sort.column, expectedLocalType);
      const b = sortValue(right.machine, sort.column, expectedLocalType);
      const aMissing = a == null || a === "";
      const bMissing = b == null || b === "";
      if (aMissing !== bMissing) return aMissing ? 1 : -1;

      let result = 0;
      if (!aMissing) {
        if (typeof a === "number") result = a - b;
        else
          result = (sort.column === "SerialNumber" ? serialCollator : textCollator).compare(
            String(a),
            String(b)
          );
      }
      if (result) return sort.direction === "desc" ? -result : result;

      const idResult = idCollator.compare(
        String(left.machine.Id ?? ""),
        String(right.machine.Id ?? "")
      );
      return idResult || left.index - right.index;
    })
    .map(({ machine }) => machine);
}
